import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import Apple from "./App";
import AboutUs from "./pages/about";
import Services from "./pages/services";
import Quote from "./pages/getaquote";
import FAQs from "./pages/faqs";
import Testimonials from "./pages/testimonials";
import Contact from "./pages/contact";

export default function App() {
  return (
    <HashRouter>
      <Routes>
          <Route index element={<Apple />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="services" element={<Services />} />
          <Route path="quote" element={<Quote />} />
          <Route path="faqs" element={<FAQs />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="contact" element={<Contact />} />
      </Routes>
    </HashRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);